import type { HTMLAttributes } from "react";
import { forwardRef, useId } from "react";

import cn from "@/helpers/cn";

import { FormItemContext } from "@/providers/formProvider/context";

const FormItem = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    const id = useId();

    return (
      <FormItemContext.Provider value={{ id }}>
        <div ref={ref} className={cn("space-y-2", className)} {...props} />
      </FormItemContext.Provider>
    );
  },
);

FormItem.displayName = "FormItem";

export default FormItem;
